import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as actions from './duck';
import ConsentForm from './form';
import styles from './styles.module.less';

import { Scrollbox, Spinner } from '$HVUI';
import colors from '$HVUI/colors.module.less';
import { HVSentry, checkIfFormErrorAndThrow } from '$Utils';

export class Consents extends React.Component {
    componentDidMount() {
        this.props.getConsents();
    }

    handleSubmit = values => {
        const { id, is_required } = this.props.activeConsent;

        const accepted = values[`${id}-agree`];

        return this.props
            .submitConsent(id, accepted)
            .then(checkIfFormErrorAndThrow);
    };

    render() {
        const { activeConsent } = this.props;

        // Redirect to the beginning of dReg in case the call to /agreements fails due to
        // a session timeout or some other reason
        if (activeConsent === 'error') return <Redirect to="/" />;
        if (activeConsent === 'complete') return <Redirect to="/forms" />;

        if (!activeConsent?.id) {
            // if there is an activeConsent with no ID, we have a problem. Capture it in Sentry.
            if (activeConsent) {
                console.error('Active consent has no ID.');
                HVSentry.sendMessageToReactSentry(
                    `Active consent has no ID. activeConsent: ${JSON.stringify(
                        activeConsent
                    )}`
                );
            }
            return (
                <div id="dynamic-consents" data-testid="dynamic-consents">
                    <Spinner id="consents" size={30} />
                </div>
            );
        }

        const { name, content, id, label, is_required } = activeConsent;

        return (
            <div
                id="dynamic-consents"
                data-testid="dynamic-consents"
                className={styles['dynamic-consents-container']}
            >
                <h1
                    style={{
                        color: colors.grayDk,
                        marginTop: '32px',
                        marginBottom: '48px'
                    }}
                >
                    {name}
                </h1>{' '}
                <Scrollbox contentID={id} contentHTML={content} />
                <ConsentForm
                    id={id}
                    label={label}
                    onSubmit={this.handleSubmit}
                    enableReinitialize={true}
                    required={is_required}
                />
            </div>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { activeConsent } = state;
    return Object.assign(
        {},
        {
            activeConsent
        },
        ownProps
    );
};

export default connect(mapStateToProps, actions)(Consents);
